module.exports = __webpack_public_path__ + "d55eb8eb3195674e38a2ce69d7ff66cd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logoTop.png
// module id = 834
// module chunks = 66